/**
 *  Icon script file
 **/

export default {
  name: 'Icon',
  mixins: [],
  components: {},
  props: {
    /**
     * Sets the icon source
     **/
    icon: {
      type: String,
      default: undefined,
      required: true
    },
    size: {
      type: [String, Array],
      default: '20px'
    },
    fill: {
      type: String,
      default: '#000000'
    }
  },
  data () {
    return {
      source: undefined
    }
  },
  computed: {},
  mounted () {
    this.getSource()
  },
  methods: {
    getSource () {
      const myRequest = require(`@/assets/icons/${this.icon}`)
      window
        .fetch(myRequest)
        .then(response => response.text())
        .then(svg => {
          this.source = svg
          this.$nextTick(() => this.drawIcon())
        })
        .catch(error => {
          // eslint-disable-next-line
          console.error(error)
        })
    },
    drawIcon () {
      const svg = this.$el.querySelector('svg')
      if (svg) {
        if (typeof this.size === 'string') {
          svg.setAttribute('width', this.size)
          svg.setAttribute('height', this.size)
        } else {
          svg.setAttribute('width', this.size[0])
          svg.setAttribute('height', this.size[1])
        }
        if (this.fill) {
          svg.setAttribute('fill', this.fill)
        }
      }
    },
    onClick (event) {
      this.$emit('click', event)
    }
  },
  watch: {
    icon (icon) {
      this.icon = icon
      this.getSource()
    },
    fill (fill) {
      this.fill = fill
      this.drawIcon()
    }
  }
}
